// Plaintext uploads from a device that doesn't have its key yet (M28). They
// stay only for families and chats from before encryption: an encrypted one
// refuses the unsealed record or message (D62, D65), but by then the file
// would already sit in storage, readable by whoever holds the bucket. So the
// scope is checked first, and nothing is uploaded when it's encrypted.
import { api, ApiError } from '../api';
import { t } from '../../i18n';
import type { ScopeKind } from './session';

export const KEYS_NOT_READY = 'KEYS_NOT_READY';

/**
 * Resolves when a file may go up unencrypted into this chat or family;
 * rejects with KEYS_NOT_READY (not retried by itself) when it's encrypted,
 * and with the request's own error when that can't be told.
 */
export async function ensurePlainUploadAllowed(
  kind: ScopeKind,
  id: string
): Promise<void> {
  // Asked fresh every time: this path is rare, and a cached answer could
  // predate the scope's first encrypted write.
  const { data } = await api.getScopeKeys(kind, id, '');
  if (data.encryptedSince) {
    throw new ApiError(t('e2ee.keysNotReady'), KEYS_NOT_READY, 409);
  }
}
